import { createDefaultText } from './text';
import { checkboxStateText } from '../../constants';
import { checkboxType } from '../types';
import type { CheckboxElement, TextProps } from '../types';

export interface CreateCheckboxArgs {
  checkboxProps: Partial<CheckboxElement>;
  isChecked?: boolean;
  textProps?: Partial<TextProps>;
}

export function createCheckboxElement(args: CreateCheckboxArgs): CheckboxElement {
  const { checkboxProps, isChecked = false, textProps = {} } = args;
  const value = checkboxStateText(isChecked);

  return {
    children: [createDefaultText(textProps, value)],
    suggestedEdits: [],
    type: checkboxType,
    ...checkboxProps,
  };
}
